(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instances = {};
    var CHECKOUT_FLAG = 'pout-checkout-pending';
    var abandonInFlight = false;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function markCheckoutPending() {
      try {
        sessionStorage.setItem(CHECKOUT_FLAG, '1');
      } catch (e) {}
    }

    function hasPendingCheckout() {
      try {
        return sessionStorage.getItem(CHECKOUT_FLAG) === '1';
      } catch (e) {
        return false;
      }
    }

    function clearPendingCheckout() {
      try {
        sessionStorage.removeItem(CHECKOUT_FLAG);
      } catch (e) {}
    }

    function firstInstance() {
      for (var id in instances) {
        if (Object.prototype.hasOwnProperty.call(instances, id) && instances[id]) {
          return instances[id];
        }
      }
      return null;
    }

    function clearCartIfAbandoned() {
      if (abandonInFlight || !hasPendingCheckout()) return;
      var instance = firstInstance();
      if (!instance) return;
      abandonInFlight = true;
      instance
        .clearCart()
        .then(function () {
          clearPendingCheckout();
          instance.adding = false;
          instance.updateCta();
        })
        .catch(function () {
          abandonInFlight = false;
        })
        .then(function () {
          abandonInFlight = false;
        });
    }

    function BuildYourBoxCarousel(section) {
      this.section = section;
      this.id = section.getAttribute('data-section-id');
      this.track = section.querySelector('[data-build-your-box-track]');
      this.slides = section.querySelectorAll('[data-build-your-box-slide]');
      this.dots = section.querySelectorAll('[data-build-your-box-dot]');
      this.tabs = section.querySelectorAll('[data-build-your-box-tab]');
      this.form = section.querySelector('form');
      this.cta = section.querySelector('[data-build-your-box-cta]');
      this.upgradeEl = section.querySelector('[data-build-your-box-upgrade]');
      this.cartAddUrl = section.getAttribute('data-cart-add-url') || '/cart/add.js';
      this.cartClearUrl = section.getAttribute('data-cart-clear-url') || '/cart/clear.js';
      this.checkoutUrl = section.getAttribute('data-checkout-url') || '/checkout';
      this.adding = false;
      this.activeIndex = 0;
      this.observer = null;
      this.bundles = section.querySelectorAll('[data-build-your-box-bundle]');
      this.variantInput = section.querySelector('[data-build-your-box-variant]');
      this.sellingPlanInput = section.querySelector('[data-build-your-box-selling-plan]');
      this.flavorsInput = section.querySelector('[data-build-your-box-flavors]');
      this.flavorGrids = section.querySelectorAll('[data-build-your-box-flavor-grid]');
      this.progressEl = section.querySelector('[data-build-your-box-progress]');
      this.slotsEl = section.querySelector('[data-build-your-box-slots]');
      this.clearBtn = section.querySelector('[data-build-your-box-clear]');
      this.countEl = section.querySelector('[data-build-your-box-progress-count]');
      this.limitEl = section.querySelector('[data-build-your-box-progress-limit]');
      this.milestoneFill = section.querySelector('[data-build-your-box-milestone-fill]');
      this.milestoneShipping = section.querySelector('[data-milestone="shipping"]');
      this.milestoneJars = section.querySelector('[data-milestone="jars"]');
      this.milestoneShippingLabel = section.querySelector('[data-milestone-label="shipping"]');
      this.milestoneJarsLabel = section.querySelector('[data-milestone-label="jars"]');
      this.shippingAt = this.progressEl
        ? Number(this.progressEl.getAttribute('data-shipping-at')) || 3
        : 3;
      this.jarsAt = this.progressEl ? Number(this.progressEl.getAttribute('data-jars-at')) || 6 : 6;
      this.selections = {};
      this.flavorLimit = 1;
      this.activeBundleId = '';
      this.boxComplete = false;

      this.onDotClick = this.onDotClick.bind(this);
      this.onBundleClick = this.onBundleClick.bind(this);
      this.onSectionClick = this.onSectionClick.bind(this);
      this.onTabClick = this.onTabClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      if (this.track && this.slides.length > 0) {
        this.bindDots();
        this.observeSlides();
      }

      this.bindBundles();
      this.bindTabs();
      this.section.addEventListener('click', this.onSectionClick);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);
      this.syncFlavorPicker(true);
    }

    BuildYourBoxCarousel.prototype.bindDots = function () {
      for (var i = 0; i < this.dots.length; i++) {
        this.dots[i].addEventListener('click', this.onDotClick);
      }
    };

    BuildYourBoxCarousel.prototype.onDotClick = function (event) {
      var index = Number(event.currentTarget.getAttribute('data-slide-index'));
      var slide = this.slides[index];
      if (!slide) return;

      slide.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        inline: 'center',
        block: 'nearest'
      });
      this.setActive(index);
    };

    BuildYourBoxCarousel.prototype.setActive = function (index) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;

      for (var i = 0; i < this.dots.length; i++) {
        var isActive = i === index;
        this.dots[i].classList.toggle('is-active', isActive);
        if (isActive) {
          this.dots[i].setAttribute('aria-current', 'true');
        } else {
          this.dots[i].removeAttribute('aria-current');
        }
      }

      for (var t = 0; t < this.tabs.length; t++) {
        var tabOn = Number(this.tabs[t].getAttribute('data-slide-index')) === index;
        this.tabs[t].classList.toggle('is-active', tabOn);
        this.tabs[t].setAttribute('aria-selected', tabOn ? 'true' : 'false');
      }
    };

    BuildYourBoxCarousel.prototype.bindTabs = function () {
      for (var i = 0; i < this.tabs.length; i++) {
        this.tabs[i].addEventListener('click', this.onTabClick);
      }
    };

    BuildYourBoxCarousel.prototype.onTabClick = function (event) {
      this.onDotClick(event);
    };

    BuildYourBoxCarousel.prototype.getCartItems = function () {
      var planId = this.sellingPlanInput ? this.sellingPlanInput.value : '';
      var items = [];
      for (var key in this.selections) {
        if (!Object.prototype.hasOwnProperty.call(this.selections, key)) continue;
        if (this.selections[key] < 1) continue;
        var line = { id: Number(key), quantity: this.selections[key] };
        if (planId) line.selling_plan = planId;
        items.push(line);
      }
      return items;
    };

    BuildYourBoxCarousel.prototype.getState = function () {
      var selectedBundle =
        this.section.querySelector('[data-build-your-box-bundle].is-selected') || this.bundles[0];
      return {
        sectionId: this.id,
        bundleId: this.activeBundleId,
        variantId: selectedBundle ? selectedBundle.getAttribute('data-variant-id') || '' : '',
        sellingPlanId: this.sellingPlanInput ? this.sellingPlanInput.value : '',
        flavorLimit: this.flavorLimit,
        flavorCount: this.getTotal(),
        complete: this.getTotal() >= this.flavorLimit && this.flavorLimit > 0 && this.bundles.length > 0,
        items: this.getCartItems()
      };
    };

    BuildYourBoxCarousel.prototype.updateCta = function () {
      if (!this.cta) return;
      var state = this.getState();
      var remaining = state.flavorLimit - state.flavorCount;
      var label;

      if (this.adding) {
        label = this.cta.getAttribute('data-label-adding') || 'adding…';
        this.cta.disabled = true;
        this.cta.classList.remove('is-ready');
      } else if (state.complete) {
        label = this.cta.getAttribute('data-label-complete') || 'add to box';
        this.cta.disabled = false;
        this.cta.classList.add('is-ready');
      } else {
        var tpl =
          remaining === 1
            ? this.cta.getAttribute('data-label-one')
            : this.cta.getAttribute('data-label-other');
        label = (tpl || 'pick __COUNT__ more flavors').replace('__COUNT__', String(Math.max(remaining, 0)));
        this.cta.disabled = true;
        this.cta.classList.remove('is-ready');
      }

      this.cta.textContent = label;
    };

    BuildYourBoxCarousel.prototype.updateBundleCopy = function () {
      var selected =
        this.section.querySelector('[data-build-your-box-bundle].is-selected') || this.bundles[0];
      if (!selected) return;

      var upgradeText = selected.getAttribute('data-upgrade-text') || '';
      var upgradeColor = selected.getAttribute('data-upgrade-color') || '';

      if (this.upgradeEl) {
        this.upgradeEl.textContent = upgradeText;
        this.upgradeEl.style.color = upgradeColor;
        if (upgradeText) {
          this.upgradeEl.removeAttribute('hidden');
        } else {
          this.upgradeEl.setAttribute('hidden', '');
        }
      }
    };

    BuildYourBoxCarousel.prototype.onSubmit = function (event) {
      event.preventDefault();
      this.addToCart();
    };

    BuildYourBoxCarousel.prototype.clearCart = function () {
      return fetch(this.cartClearUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart clear error');
        return response.json();
      });
    };

    BuildYourBoxCarousel.prototype.addToCart = function () {
      var self = this;
      var state = this.getState();
      if (!state.complete || this.adding) return;
      if (!state.items.length) return;

      this.adding = true;
      this.updateCta();

      this.clearCart()
        .catch(function () {})
        .then(function () {
          return fetch(self.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items: state.items })
          });
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              var err = new Error((data && data.description) || 'Cart error');
              throw err;
            });
          }
          return response.json();
        })
        .then(function () {
          markCheckoutPending();
          window.location.href = self.checkoutUrl;
        })
        .catch(function () {
          self.adding = false;
          self.updateCta();
        });
    };

    BuildYourBoxCarousel.prototype.bindBundles = function () {
      for (var i = 0; i < this.bundles.length; i++) {
        this.bundles[i].addEventListener('click', this.onBundleClick);
      }
    };

    BuildYourBoxCarousel.prototype.onBundleClick = function (event) {
      var button = event.currentTarget;
      this.setSelectedBundle(button);
    };

    BuildYourBoxCarousel.prototype.setSelectedBundle = function (button) {
      var planId = button.getAttribute('data-selling-plan-id') || '';
      var variantId = button.getAttribute('data-variant-id') || '';

      for (var i = 0; i < this.bundles.length; i++) {
        var isSelected = this.bundles[i] === button;
        this.bundles[i].classList.toggle('is-selected', isSelected);
        this.bundles[i].setAttribute('aria-checked', isSelected ? 'true' : 'false');
      }

      if (this.variantInput) this.variantInput.value = variantId;
      if (this.sellingPlanInput) this.sellingPlanInput.value = planId;

      this.syncFlavorPicker(false);

      this.section.dispatchEvent(
        new CustomEvent('build-your-box:bundle-change', {
          bubbles: true,
          detail: {
            sectionId: this.id,
            variantId: variantId,
            sellingPlanId: planId
          }
        })
      );
    };

    BuildYourBoxCarousel.prototype.onSectionClick = function (event) {
      var clear = event.target.closest('[data-build-your-box-clear]');
      if (clear && this.section.contains(clear)) {
        event.preventDefault();
        this.clearFlavors();
        return;
      }

      var minus = event.target.closest('[data-build-your-box-flavor-minus]');
      if (minus && this.section.contains(minus)) {
        event.preventDefault();
        this.adjustFlavor(minus.getAttribute('data-variant-id'), -1);
        return;
      }

      var plus = event.target.closest('[data-build-your-box-flavor-plus]');
      if (plus && this.section.contains(plus)) {
        event.preventDefault();
        if (this.adjustFlavor(plus.getAttribute('data-variant-id'), 1)) {
          this.pulseFlavorPlus(plus.closest('[data-build-your-box-flavor]'));
        }
        return;
      }

      var flavor = event.target.closest('[data-build-your-box-flavor]');
      if (!flavor || !this.section.contains(flavor)) return;
      if (flavor.classList.contains('is-disabled')) return;
      if (flavor.getAttribute('aria-disabled') === 'true') return;

      var grid = flavor.closest('[data-build-your-box-flavor-grid]');
      if (!grid || grid.hidden) return;

      event.preventDefault();
      if (this.adjustFlavor(flavor.getAttribute('data-variant-id'), 1)) {
        this.pulseFlavorPlus(flavor);
      }
    };

    BuildYourBoxCarousel.prototype.syncFlavorPicker = function (keepSelections) {
      var selected = this.section.querySelector('[data-build-your-box-bundle].is-selected') || this.bundles[0];
      if (!selected) return;

      this.flavorLimit = Number(selected.getAttribute('data-flavor-limit')) || 1;
      this.activeBundleId = selected.getAttribute('data-bundle-id') || '';
      if (!keepSelections) this.selections = {};

      for (var i = 0; i < this.flavorGrids.length; i++) {
        var isActive = this.flavorGrids[i].getAttribute('data-bundle-id') === this.activeBundleId;
        this.flavorGrids[i].classList.toggle('is-active', isActive);
        if (isActive) {
          this.flavorGrids[i].removeAttribute('hidden');
        } else {
          this.flavorGrids[i].setAttribute('hidden', '');
        }
      }

      this.refreshFlavorUI();
      this.updateBundleCopy();
    };

    BuildYourBoxCarousel.prototype.getTotal = function () {
      var total = 0;
      for (var id in this.selections) {
        if (Object.prototype.hasOwnProperty.call(this.selections, id)) {
          total += this.selections[id];
        }
      }
      return total;
    };

    BuildYourBoxCarousel.prototype.removeCompleteRain = function () {
      if (this._rainTimer) {
        window.clearTimeout(this._rainTimer);
        this._rainTimer = null;
      }
      if (this._rainLayer && this._rainLayer.parentNode) {
        this._rainLayer.parentNode.removeChild(this._rainLayer);
      }
      this._rainLayer = null;
    };

    BuildYourBoxCarousel.prototype.clearSlot = function (slot) {
      if (!slot) return;
      slot.className = 'build-your-box__slot';
      slot.removeAttribute('data-filled-id');
      slot.textContent = '';
    };

    BuildYourBoxCarousel.prototype.spawnCompleteRain = function (grid) {
      if (!grid) return;
      this.removeCompleteRain();

      var cards = grid.querySelectorAll('[data-build-your-box-flavor]');
      var pool = [];
      for (var i = 0; i < cards.length; i++) {
        var glyph = this.getFlavorGlyph(cards[i]);
        if (!glyph) continue;
        var copies = 16 + Math.floor(Math.random() * 12);
        for (var n = 0; n < copies; n++) pool.push(glyph);
      }
      if (!pool.length) return;

      for (var s = pool.length - 1; s > 0; s--) {
        var k = Math.floor(Math.random() * (s + 1));
        var tmp = pool[s];
        pool[s] = pool[k];
        pool[k] = tmp;
      }

      var sectionRect = this.section.getBoundingClientRect();
      var sectionBottom = sectionRect.bottom;
      var vw = window.innerWidth || 360;
      var layer = document.createElement('div');
      layer.className = 'build-your-box__rain-layer';
      layer.setAttribute('aria-hidden', 'true');
      if (this.id) layer.setAttribute('data-section-id', this.id);

      var maxEnd = 0;
      for (var d = 0; d < pool.length; d++) {
        var drop = document.createElement('span');
        drop.className = 'build-your-box__slot-rain';
        var spin = document.createElement('span');
        spin.className = 'build-your-box__slot-rain-spin';
        this.appendFlavorGlyph(spin, pool[d]);
        drop.appendChild(spin);

        var startX = Math.random() * vw;
        var startY = -32 - Math.random() * 220;
        var endX = startX + (Math.random() * 70 - 35);
        var endY = sectionBottom - 8 - Math.random() * 28;
        var travel = Math.max(240, endY - startY);
        var delay = Math.random() * 420;
        var speed = 620 + Math.random() * 140;
        var dur = (travel / speed) * 1000;
        drop.style.left = startX + 'px';
        drop.style.top = startY + 'px';
        drop.style.fontSize = (0.9 + Math.random() * 0.85).toFixed(2) + 'rem';
        drop.style.setProperty('--end-x', (endX - startX).toFixed(1) + 'px');
        drop.style.setProperty('--end-y', (endY - startY).toFixed(1) + 'px');
        drop.style.setProperty('--dur', dur + 'ms');
        drop.style.setProperty('--delay', delay + 'ms');
        layer.appendChild(drop);
        if (delay + dur > maxEnd) maxEnd = delay + dur;
      }

      document.body.appendChild(layer);
      this._rainLayer = layer;

      var self = this;
      this._rainTimer = window.setTimeout(function () {
        self.removeCompleteRain();
      }, maxEnd + 200);
    };

    BuildYourBoxCarousel.prototype.getFlavorGlyph = function (card) {
      if (!card) return null;
      var iconImg = card.querySelector('.build-your-box__flavor-icon img');
      if (iconImg && iconImg.getAttribute('src')) {
        return { type: 'img', src: iconImg.getAttribute('src') };
      }
      var svg = card.querySelector('.build-your-box__flavor-icon svg');
      if (svg) return { type: 'svg', node: svg };
      var emoji = card.getAttribute('data-emoji') || '';
      if (emoji) return { type: 'emoji', emoji: emoji };
      var iconSrc = card.getAttribute('data-icon-src') || '';
      if (iconSrc) return { type: 'img', src: iconSrc };
      return null;
    };

    BuildYourBoxCarousel.prototype.appendFlavorGlyph = function (parent, glyph) {
      if (!parent || !glyph) return;
      if (glyph.type === 'svg' && glyph.node) {
        parent.appendChild(glyph.node.cloneNode(true));
        return;
      }
      if (glyph.type === 'emoji' && glyph.emoji) {
        parent.textContent = glyph.emoji;
        return;
      }
      if (glyph.type === 'img' && glyph.src) {
        var img = document.createElement('img');
        img.src = glyph.src;
        img.alt = '';
        img.className = 'build-your-box__flavor-emoji-img';
        parent.appendChild(img);
      }
    };

    BuildYourBoxCarousel.prototype.fillSlot = function (slot, flavorId, swatch, glyph) {
      if (!slot) return;
      if (slot.getAttribute('data-filled-id') === flavorId && slot.classList.contains('is-filled')) {
        return;
      }

      slot.className = 'build-your-box__slot is-filled build-your-box__flavor-icon--' + swatch;
      slot.setAttribute('data-filled-id', flavorId);
      slot.textContent = '';

      var icon = document.createElement('span');
      icon.className = 'build-your-box__slot-icon';
      icon.setAttribute('aria-hidden', 'true');
      this.appendFlavorGlyph(icon, glyph);
      slot.appendChild(icon);
    };

    BuildYourBoxCarousel.prototype.clearFlavors = function () {
      if (this.getTotal() < 1) return;
      this.selections = {};
      this.boxComplete = false;
      this.removeCompleteRain();
      this.refreshFlavorUI();
    };

    BuildYourBoxCarousel.prototype.pulseFlavorPlus = function (card) {
      if (!card || prefersReducedMotion()) return;
      var pop = document.createElement('span');
      pop.className = 'build-your-box__flavor-plus-pop';
      pop.setAttribute('aria-hidden', 'true');
      pop.textContent = '+';
      card.appendChild(pop);
      window.setTimeout(function () {
        if (pop.parentNode) pop.parentNode.removeChild(pop);
      }, 480);
    };

    BuildYourBoxCarousel.prototype.adjustFlavor = function (variantId, delta) {
      if (!variantId) return false;

      var qty = this.selections[variantId] || 0;
      var total = this.getTotal();
      var next = qty + delta;

      if (next < 0) next = 0;
      if (delta > 0 && total >= this.flavorLimit) return false;
      if (next === qty) return false;

      if (next === 0) {
        delete this.selections[variantId];
      } else {
        this.selections[variantId] = next;
      }

      this.refreshFlavorUI();
      return true;
    };

    BuildYourBoxCarousel.prototype.refreshFlavorUI = function () {
      var total = this.getTotal();
      var atLimit = total >= this.flavorLimit;
      var activeGrid = null;

      for (var i = 0; i < this.flavorGrids.length; i++) {
        if (this.flavorGrids[i].getAttribute('data-bundle-id') === this.activeBundleId) {
          activeGrid = this.flavorGrids[i];
          break;
        }
      }

      if (activeGrid) {
        var cards = activeGrid.querySelectorAll('[data-build-your-box-flavor]');
        for (var b = 0; b < cards.length; b++) {
          var card = cards[b];
          var id = card.getAttribute('data-variant-id');
          var qty = this.selections[id] || 0;
          var selected = qty > 0;
          var unavailable = card.getAttribute('aria-disabled') === 'true';
          var qtyEl = card.querySelector('[data-flavor-qty]');
          var addBtn = card.querySelector('.build-your-box__flavor-add');
          var plusBtn = card.querySelector('.build-your-box__flavor-step--plus');
          var stepper = card.querySelector('[data-flavor-stepper]');

          card.classList.toggle('is-selected', selected);
          card.classList.toggle('is-disabled', unavailable || (atLimit && !selected));

          if (qtyEl) {
            qtyEl.textContent = String(qty);
            if (qty > 0) {
              qtyEl.removeAttribute('hidden');
            } else {
              qtyEl.setAttribute('hidden', '');
            }
          }

          if (stepper) {
            if (selected) {
              stepper.removeAttribute('hidden');
            } else {
              stepper.setAttribute('hidden', '');
            }
          }

          if (addBtn && !unavailable) addBtn.disabled = atLimit && !selected;
          if (plusBtn) plusBtn.disabled = atLimit;
        }
      }

      if (this.countEl) this.countEl.textContent = String(total);
      if (this.limitEl) this.limitEl.textContent = String(this.flavorLimit);
      if (this.clearBtn) {
        if (total < 1) {
          this.clearBtn.setAttribute('hidden', '');
        } else {
          this.clearBtn.removeAttribute('hidden');
        }
      }

      if (this.slotsEl) {
        if (this.slotsEl.children.length !== this.flavorLimit) {
          var existing = this.slotsEl.children;
          for (var c = 0; c < existing.length; c++) {
            this.clearSlot(existing[c]);
          }
          var html = '';
          for (var s = 0; s < this.flavorLimit; s++) {
            html += '<div class="build-your-box__slot"></div>';
          }
          this.slotsEl.innerHTML = html;
        }
        this.slotsEl.setAttribute('aria-valuenow', String(total));
        this.slotsEl.setAttribute('aria-valuemax', String(this.flavorLimit));

        var filledIds = [];
        for (var key in this.selections) {
          if (!Object.prototype.hasOwnProperty.call(this.selections, key)) continue;
          var qty = this.selections[key];
          for (var n = 0; n < qty; n++) filledIds.push(key);
        }

        var slots = this.slotsEl.children;
        for (var j = 0; j < slots.length; j++) {
          var slot = slots[j];
          var flavorId = filledIds[j];
          if (!flavorId || !activeGrid) {
            this.clearSlot(slot);
            continue;
          }

          var flavorCard = activeGrid.querySelector(
            '[data-build-your-box-flavor][data-variant-id="' + flavorId + '"]'
          );
          if (!flavorCard) {
            this.clearSlot(slot);
            continue;
          }

          var swatch = flavorCard.getAttribute('data-swatch-index') || '0';
          this.fillSlot(slot, flavorId, swatch, this.getFlavorGlyph(flavorCard));
        }
      }

      var justCompleted = atLimit && !this.boxComplete;
      this.boxComplete = atLimit;
      if (justCompleted && !prefersReducedMotion()) {
        this.spawnCompleteRain(activeGrid);
      }

      var fillRatio = this.jarsAt > 0 ? Math.min(1, total / this.jarsAt) : 0;
      if (this.milestoneFill) {
        this.milestoneFill.style.width = '';
        this.milestoneFill.style.setProperty('--milestone-fill', String(fillRatio));
      }

      var shippingReached = total >= this.shippingAt;
      var jarsReached = total >= this.jarsAt;
      if (this.milestoneShipping) this.milestoneShipping.classList.toggle('is-reached', shippingReached);
      if (this.milestoneJars) this.milestoneJars.classList.toggle('is-reached', jarsReached);
      if (this.milestoneShippingLabel) {
        this.milestoneShippingLabel.classList.toggle('is-reached', shippingReached);
      }
      if (this.milestoneJarsLabel) this.milestoneJarsLabel.classList.toggle('is-reached', jarsReached);

      var planId = this.sellingPlanInput ? this.sellingPlanInput.value : '';
      var items = [];
      for (var key in this.selections) {
        if (!Object.prototype.hasOwnProperty.call(this.selections, key)) continue;
        if (this.selections[key] < 1) continue;
        var title = '';
        if (activeGrid) {
          var match = activeGrid.querySelector(
            '[data-build-your-box-flavor][data-variant-id="' + key + '"]'
          );
          if (match) title = match.getAttribute('data-variant-title') || '';
        }
        items.push({
          id: Number(key),
          quantity: this.selections[key],
          title: title,
          selling_plan: planId
        });
      }

      if (this.flavorsInput) this.flavorsInput.value = JSON.stringify(items);

      this.updateCta();

      this.section.dispatchEvent(
        new CustomEvent('build-your-box:flavors-change', {
          bubbles: true,
          detail: this.getState()
        })
      );
    };

    BuildYourBoxCarousel.prototype.observeSlides = function () {
      var self = this;
      this.observer = new IntersectionObserver(
        function (entries) {
          var best = null;
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            if (!best || entries[i].intersectionRatio > best.intersectionRatio) {
              best = entries[i];
            }
          }
          if (!best) return;
          var index = Number(best.target.getAttribute('data-slide-index'));
          self.setActive(index);
        },
        {
          root: this.track,
          threshold: [0.45, 0.6, 0.75]
        }
      );

      for (var i = 0; i < this.slides.length; i++) {
        this.observer.observe(this.slides[i]);
      }
    };

    BuildYourBoxCarousel.prototype.destroy = function () {
      if (this.observer) this.observer.disconnect();
      this.removeCompleteRain();
      var leftover = document.querySelectorAll(
        '.build-your-box__rain-layer[data-section-id="' + this.id + '"]'
      );
      for (var l = 0; l < leftover.length; l++) {
        if (leftover[l].parentNode) leftover[l].parentNode.removeChild(leftover[l]);
      }
      this.section.removeEventListener('click', this.onSectionClick);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      for (var i = 0; i < this.dots.length; i++) {
        this.dots[i].removeEventListener('click', this.onDotClick);
      }
      for (var t = 0; t < this.tabs.length; t++) {
        this.tabs[t].removeEventListener('click', this.onTabClick);
      }
      for (var j = 0; j < this.bundles.length; j++) {
        this.bundles[j].removeEventListener('click', this.onBundleClick);
      }
    };

    function init(section) {
      var id = section.getAttribute('data-section-id');
      if (!id) return;
      if (instances[id]) instances[id].destroy();
      instances[id] = new BuildYourBoxCarousel(section);
    }

    function initAll() {
      var sections = document.querySelectorAll('[data-build-your-box]');
      for (var i = 0; i < sections.length; i++) {
        init(sections[i]);
      }
    }

    function destroyById(id) {
      if (!instances[id]) return;
      instances[id].destroy();
      delete instances[id];
    }

    initAll();
    clearCartIfAbandoned();
    window.addEventListener('pageshow', clearCartIfAbandoned);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-build-your-box]');
      if (section) init(section);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.detail && event.detail.sectionId) {
        destroyById(event.detail.sectionId);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instances = {};

    function PromoBar(section) {
      this.root = section;
      this.id = section.getAttribute('data-section-id');
      this.storageKey = section.getAttribute('data-storage-key');
      this.closeBtn = section.querySelector('[data-promo-bar-close]');
      this.onClose = this.hide.bind(this);
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.onClose);
    }

    PromoBar.prototype.hide = function () {
      this.root.hidden = true;
      try {
        sessionStorage.setItem(this.storageKey, '1');
      } catch (e) {}
    };

    PromoBar.prototype.destroy = function () {
      if (this.closeBtn) this.closeBtn.removeEventListener('click', this.onClose);
    };

    function init(section) {
      var id = section.getAttribute('data-section-id');
      if (!id) return;
      if (instances[id]) instances[id].destroy();
      if (section.getAttribute('data-dismissable') !== 'true') return;
      instances[id] = new PromoBar(section);
    }

    function initAll() {
      var sections = document.querySelectorAll('[data-promo-bar]');
      for (var i = 0; i < sections.length; i++) init(sections[i]);
    }

    function destroyById(id) {
      if (!instances[id]) return;
      instances[id].destroy();
      delete instances[id];
    }

    initAll();

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-promo-bar]') || event.target;
      if (section && section.hasAttribute && section.hasAttribute('data-promo-bar')) init(section);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var section = event.target.querySelector('[data-promo-bar]') || event.target;
      if (section && section.getAttribute) destroyById(section.getAttribute('data-section-id'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instances = {};

    function StickyCta(root) {
      this.root = root;
      this.id = root.getAttribute('data-section-id');
      this.link = root.querySelector('[data-sticky-cta-link]');
      this.heroSelector = root.getAttribute('data-hero-selector') || '.hero';
      this.footerSelector = root.getAttribute('data-footer-selector') || '.site-footer';
      this.fallbackPx = Number(root.getAttribute('data-fallback-px')) || 320;
      this.hero = document.querySelector(this.heroSelector);
      this.footer = document.querySelector(this.footerSelector);
      this.target = this.findTarget();
      this.heroVisible = !!this.hero;
      this.targetVisible = false;
      this.footerVisible = false;
      this.observers = [];
      this.onScroll = this.onScroll.bind(this);
      this.onLinkClick = this.onLinkClick.bind(this);
      this.ticking = false;

      this.observeHero();
      this.observeTarget();
      this.observeFooter();
      if (this.link) this.link.addEventListener('click', this.onLinkClick);
      if (!this.hero) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
      this.sync();
    }

    StickyCta.prototype.findTarget = function () {
      if (!this.link) return null;
      var href = this.link.getAttribute('href') || '';
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return null;
      var hash = href.slice(hashIndex);
      if (hash.length < 2) return null;
      try {
        return document.querySelector(hash);
      } catch (e) {
        return null;
      }
    };

    StickyCta.prototype.onLinkClick = function (event) {
      if (!this.target) return;
      var href = this.link.getAttribute('href') || '';
      if (href.charAt(0) !== '#') {
        try {
          var url = new URL(href, window.location.href);
          if (url.pathname !== window.location.pathname) return;
        } catch (e) {
          return;
        }
      }
      event.preventDefault();
      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.target.scrollIntoView({
        behavior: reduced ? 'auto' : 'smooth',
        block: 'start'
      });
    };

    StickyCta.prototype.observeHero = function () {
      if (!this.hero || typeof IntersectionObserver === 'undefined') return;
      var self = this;
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          self.heroVisible = !!(entry && entry.isIntersecting);
          self.sync();
        },
        { threshold: 0 }
      );
      observer.observe(this.hero);
      this.observers.push(observer);
    };

    StickyCta.prototype.observeTarget = function () {
      if (!this.target || typeof IntersectionObserver === 'undefined') return;
      var self = this;
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          self.targetVisible = !!(entry && entry.isIntersecting);
          self.sync();
        },
        { threshold: 0.2 }
      );
      observer.observe(this.target);
      this.observers.push(observer);
    };

    StickyCta.prototype.observeFooter = function () {
      if (!this.footer || typeof IntersectionObserver === 'undefined') return;
      var self = this;
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          self.footerVisible = !!(entry && entry.isIntersecting);
          self.sync();
        },
        { threshold: 0.1 }
      );
      observer.observe(this.footer);
      this.observers.push(observer);
    };

    StickyCta.prototype.onScroll = function () {
      if (this.ticking) return;
      this.ticking = true;
      var self = this;
      window.requestAnimationFrame(function () {
        self.ticking = false;
        self.heroVisible = window.scrollY < self.fallbackPx;
        self.sync();
      });
    };

    StickyCta.prototype.sync = function () {
      var show = !this.heroVisible && !this.targetVisible && !this.footerVisible;
      this.root.classList.toggle('is-visible', show);
      this.root.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (this.link) this.link.tabIndex = show ? 0 : -1;
    };

    StickyCta.prototype.destroy = function () {
      for (var i = 0; i < this.observers.length; i++) this.observers[i].disconnect();
      window.removeEventListener('scroll', this.onScroll);
      if (this.link) this.link.removeEventListener('click', this.onLinkClick);
    };

    function init(root) {
      var id = root.getAttribute('data-section-id');
      if (!id) return;
      if (instances[id]) instances[id].destroy();
      instances[id] = new StickyCta(root);
    }

    function initAll() {
      var sections = document.querySelectorAll('[data-sticky-cta]');
      for (var i = 0; i < sections.length; i++) init(sections[i]);
    }

    function destroyById(id) {
      if (!instances[id]) return;
      instances[id].destroy();
      delete instances[id];
    }

    initAll();

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-sticky-cta]') || event.target;
      if (root && root.hasAttribute && root.hasAttribute('data-sticky-cta')) init(root);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-sticky-cta]') || event.target;
      if (root && root.getAttribute) destroyById(root.getAttribute('data-section-id'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stress-curve"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-stress-curve]';
    var items = [];
    var ticking = false;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function setDot(dot, point, opacity) {
      dot.setAttribute('cx', point.x);
      dot.setAttribute('cy', point.y);
      dot.setAttribute('opacity', String(opacity));
    }

    function applyMood(item, progress) {
      if (!item.mood) return;
      var exhaled = progress >= 0.5;
      if (item.moodExhaled === exhaled) return;
      item.moodExhaled = exhaled;
      var nextLabel = exhaled ? item.labelExhaled : item.labelWired;
      if (nextLabel) item.mood.textContent = nextLabel;
      item.el.style.setProperty(
        '--stress-curve-mood-color',
        exhaled ? item.colorExhaled : item.colorWired
      );
    }

    function apply(item, progress) {
      item.el.style.setProperty('--stress-curve-p', progress.toFixed(4));
      applyMood(item, progress);
      if (!item.dot || !item.path || !item.length) return;
      if (progress <= 0.01) {
        setDot(item.dot, item.path.getPointAtLength(0), 0);
        return;
      }
      setDot(item.dot, item.path.getPointAtLength(progress * item.length), 1);
    }

    function measure() {
      ticking = false;
      var reduced = prefersReducedMotion();
      var vh = window.innerHeight || 1;
      var start = vh * 0.88;
      var end = vh * 0.36;
      var span = start - end || 1;

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (reduced) {
          apply(item, 1);
          continue;
        }
        var top = item.track.getBoundingClientRect().top;
        var progress = (start - top) / span;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        apply(item, progress);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    function collect() {
      items = [];
      var sections = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < sections.length; i++) {
        var el = sections[i];
        var path = el.querySelector('.stress-curve__path');
        var dot = el.querySelector('.stress-curve__dot');
        var mood = el.querySelector('[data-stress-curve-mood]');
        var track = el.querySelector('.stress-curve__card') || el;
        var length = 0;
        if (path && typeof path.getTotalLength === 'function') {
          length = path.getTotalLength();
        }
        var styles = window.getComputedStyle(el);
        items.push({
          el: el,
          track: track,
          path: path,
          dot: dot,
          mood: mood,
          length: length,
          moodExhaled: null,
          labelWired: mood ? mood.getAttribute('data-label-wired') || '' : '',
          labelExhaled: mood ? mood.getAttribute('data-label-exhaled') || '' : '',
          colorWired: styles.getPropertyValue('--stress-curve-header-start-color').trim() || 'rgb(224, 50, 123)',
          colorExhaled: styles.getPropertyValue('--stress-curve-header-highlight-color').trim() || 'rgb(46, 158, 107)'
        });
      }
      onScroll();
    }

    collect();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', collect);
    document.addEventListener('shopify:section:reorder', collect);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-chat"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sections = [];
    var ticking = false;

    function measure() {
      ticking = false;
      var vh = window.innerHeight || 1;
      var start = vh * 0.95;
      var end = vh * 0.55;
      var span = start - end || 1;

      sections.forEach(function (section) {
        var bubbles = section.querySelectorAll('[data-testimonial-chat-bubble]');
        for (var i = 0; i < bubbles.length; i++) {
          var top = bubbles[i].getBoundingClientRect().top;
          var progress = (start - top) / span;
          if (progress < 0) progress = 0;
          if (progress > 1) progress = 1;
          bubbles[i].style.setProperty('--testimonial-chat-in', progress.toFixed(3));
        }
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    function collect() {
      sections = Array.prototype.slice.call(document.querySelectorAll('.testimonial-chat'));
      onScroll();
    }

    collect();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', collect);
  })();

  } catch(e) { console.error(e); }
})();
})();
